import {
  HStack,
  Icon,
  Step,
  StepIndicator,
  Stepper,
  StepSeparator,
  StepStatus,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { RiMapPin2Fill, RiMapPin2Line, RiTruckLine } from "@remixicon/react";
import { HistoryTrackOrderInterface } from "../../constants/TrackOrder";
import { formatDate, formatTime } from "../../utils/helperFunction";

interface Props {
  data: HistoryTrackOrderInterface[] | undefined;
}

export const TrackOrderStepper = ({ data, ...rest }: Props) => {
  const icColor = useColorModeValue("red.400", "red.200");

  return (
    <Stepper
      index={0}
      colorScheme="red"
      gap={6}
      orientation="vertical"
      size={["xs", null, "sm"]}
      {...rest}
    >
      {data?.map((item, i) => (
        <Step key={i}>
          <StepIndicator>
            <StepStatus
              complete={<Icon as={RiMapPin2Line} />}
              incomplete={<Icon as={RiMapPin2Line} />}
              active={<Icon as={RiMapPin2Fill} color={icColor} />}
            />
          </StepIndicator>

          <VStack gap={0} align={"stretch"}>
            <HStack gap={1} flexShrink={0}>
              <Icon as={RiTruckLine} opacity={0.6} fontSize={[10, null, 12]} />
              <Text fontSize={[8, null, 10]}>{item.lokasi}</Text>
            </HStack>

            <Text textStyle={"b-sm-sb"}>{item.desc}</Text>
            <Text fontSize={[8, null, 10]} variant={"secondary"}>
              {`${formatDate(item.tanggal.toString())} | ${formatTime(
                item.tanggal.toString()
              )}`}
            </Text>
          </VStack>

          <StepSeparator />
        </Step>
      ))}
    </Stepper>
  );
};
